import anchorClickHandler from '../../../assets/scripts/modules/anchor-click-handler.js'
import Component, { loadComponent } from '../../../assets/scripts/modules/component.js'

class CursorComponent extends Component {
  init() {
    this.element.href && this.element.addEventListener('click', event => anchorClickHandler(this.element.href, event))
  }
}

window.addEventListener('init-load', () => loadComponent(document, 'cursor', CursorComponent))
